<template>
  <div class="container fluid">
    <v-card>
      <RoboInvestingSavingPlansTable />
    </v-card>
  </div>
</template>

<script>
import RoboInvestingSavingPlansTable from '@/components/roboInvesting/RoboInvestingSavingPlansTable';

export default {
  name: 'RoboInvestingSavingPlans',
  components: {
    RoboInvestingSavingPlansTable,
  },
  data() {
    return {

    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/roboInvesting/RoboInvestingSavingPlans.vue